import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Image } from 'foundations-components/transitional/components/Image';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { List } from 'foundations-components/transitional/components/List';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AssetReviewWizardHeader({
  name,
  offeringType,
  providerName,
  thumbnailUrl,
  versionNumber
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlock: "200",
      paddingInline: "900",
      children: /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(GridItem, {
          size: 2,
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            blockSize: "100%",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.assets.reviews.wizard.write"
            })
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          size: 8,
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            flexDirection: "column",
            children: /*#__PURE__*/_jsx(View, {
              children: /*#__PURE__*/_jsxs(MediaObject, {
                align: "center",
                itemLeft: /*#__PURE__*/_jsx(Image, {
                  alt: name,
                  inlineSize: "100px",
                  src: thumbnailUrl
                }),
                children: [/*#__PURE__*/_jsx(Text, {
                  as: "h4",
                  children: name
                }), /*#__PURE__*/_jsx(Badge, {
                  marginInlineEnd: "200",
                  use: "koala",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `marketplace-assets-ui.assets.reviews.wizard.header.${offeringType}_BADGE`
                  })
                }), /*#__PURE__*/_jsxs(List, {
                  inline: true,
                  use: "inline-divided",
                  children: [providerName && /*#__PURE__*/_jsx(Text, {
                    as: "small",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "marketplace-assets-ui.assets.reviews.wizard.header.PROVIDER",
                      options: {
                        provider: providerName
                      }
                    })
                  }), versionNumber && /*#__PURE__*/_jsx(Text, {
                    as: "small",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "marketplace-assets-ui.assets.reviews.wizard.header.VERSION",
                      options: {
                        version: versionNumber
                      }
                    })
                  })]
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          size: 2
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingInline: "500",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "flush"
      })
    })]
  });
}